/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Credentials
 */
export interface Credentials {
    /**
     * 
     * @type {string}
     * @memberof Credentials
     */
    username?: string;
    /**
     * 
     * @type {string}
     * @memberof Credentials
     */
    password?: string;
}

/**
 * Check if a given object implements the Credentials interface.
 */
export function instanceOfCredentials(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CredentialsFromJSON(json: any): Credentials {
    return CredentialsFromJSONTyped(json, false);
}

export function CredentialsFromJSONTyped(json: any, ignoreDiscriminator: boolean): Credentials {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'username': !exists(json, 'username') ? undefined : json['username'],
        'password': !exists(json, 'password') ? undefined : json['password'],
    };
}

export function CredentialsToJSON(value?: Credentials | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'username': value.username,
        'password': value.password,
    };
}

